module.exports = __webpack_public_path__ + "img/travel_insurance.c44ce97e.png";